import { render } from "./StudyCreationComponent.vue?vue&type=template&id=b3c5edaa&scoped=true"
import script from "./StudyCreationComponent.vue?vue&type=script&lang=js"
export * from "./StudyCreationComponent.vue?vue&type=script&lang=js"

import "./StudyCreationComponent.vue?vue&type=style&index=0&id=b3c5edaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3c5edaa"]])

export default __exports__